import React, { useState, useImperativeHandle, forwardRef } from "react";
import {
  Paper,
  IconButton,
  Menu,
  MenuItem,
  Typography,
} from "@material-ui/core";
import { MoreVert as MoreIcon } from "@material-ui/icons";
import classnames from "classnames";

// styles
import useStyles from "./styles";

//export default function Widget({
const Widget = forwardRef(({
  children,
  title,
  noBodyPadding,
  bodyClass,
  disableWidgetMenu,
  header,
  noShadow,
  noMinHeight,
  showOverflow,
  noHeader,
  menuItems,
  style,
  ...props
}, ref) =>  {
  var classes = useStyles();

  // local
  var [moreButtonRef, setMoreButtonRef] = useState(null);
  var [isMoreMenuOpen, setMoreMenuOpen] = useState(false);

  useImperativeHandle(ref, () => ({

     closeWidgetMoreMenu() {
      setMoreMenuOpen(false);
    }

}));

  return (
    <div className={noShadow ? classes.widgetWrapperNoShadow : (noMinHeight ? classes.widgetWrapperNoMinHeight : classes.widgetWrapper)} style={style}>
      <Paper className={noShadow ? classes.paperNoShadow : (showOverflow ? classes.paperShowOverflow : classes.paper)} classes={{ root: (noShadow ? classes.widgetRootNoShadow :  classes.widgetRoot )}}>
        {noHeader ? (<span className={classes.hidden}></span>) : (
          <div className={classes.widgetHeader}>
            {header ? (
              header
            ) : (
              <React.Fragment>
                <Typography variant="h5" color="textSecondary">
                  {title}
                </Typography>
                {!disableWidgetMenu && (
                  <IconButton
                    color="primary"
                    classes={{ root: classes.moreButton }}
                    aria-owns="widget-menu"
                    aria-haspopup="true"
                    onClick={() => setMoreMenuOpen(true)}
                    buttonRef={setMoreButtonRef}
                  >
                    <MoreIcon />
                  </IconButton>
                )}
              </React.Fragment>
            )}
          </div>
        )}
        <div
          className={classnames(noShadow ? classes.widgetBodyNoShadow : classes.widgetBody, {
            [classes.noPadding]: noBodyPadding,
            [bodyClass]: bodyClass,
          })}
        >
          {children}
        </div>
      </Paper>
      <Menu
        id="widget-menu"
        open={isMoreMenuOpen}
        anchorEl={moreButtonRef}
        onClose={() => setMoreMenuOpen(false)}
        disableAutoFocusItem
      >
        {/*<MenuItem>
          <Typography>Edit</Typography>
        </MenuItem>
        <MenuItem>
          <Typography>Copy</Typography>
        </MenuItem>
        <MenuItem>
          <Typography>Delete</Typography>
        </MenuItem>
        <MenuItem>
          <Typography>Print</Typography>
        </MenuItem>*/}
        {menuItems}
      </Menu>
    </div>
  );
//}
});
export default Widget;
